import { RegistryItemFragment } from '@graphql/generated';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { useDisclosure } from '@withjoy/joykit';
import { useEffect, useState } from 'react';
import { createRegistryItemSubject } from '../..';

export const useDrawerVisibilty = () => {
  const [currentItem, setCurrentItem] = useState<RegistryItemFragment | null>(null);
  const { isOpen, onClose, onOpen } = useDisclosure();

  const openDrawer = useEventCallback((item: RegistryItemFragment) => {
    setCurrentItem(item);
    onOpen();
  });

  useEffect(() => {
    const sub = createRegistryItemSubject.subscribe(data => {
      if (!data.purchaseMethod) {
        openDrawer(data.item);
      }
    });

    return () => {
      sub.unsubscribe();
    };
  }, [openDrawer]);

  return {
    currentItem,
    isOpen,
    onClose
  };
};
